<div class="no-cont-placeholder">
    <div class="no-cont-placeholder-icons">
        <span class="hd-icon hd-icon-nodevice"></span>
        <span class="hd-icon hd-icon-notickets"></span>
     </div>
    <div class="no-cont-placeholder-caption">
        {{'ssp_no_content_placeholder_caption'|xsI18n}}
    </div>
</div>